// extracted by mini-css-extract-plugin
module.exports = {"container":"institution-icon_container__0qqFZ","disabled":"institution-icon_disabled___Lawl","bubble":"institution-icon_bubble__kfh_l"};